import { Component, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: { componentStack: string }) {
    // eslint-disable-next-line no-console
    console.error("ClubConnect crashed:", error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <main className="mx-auto flex min-h-dvh max-w-md flex-col items-center justify-center px-6 text-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-full bg-flag-100 text-flag-600">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" className="h-7 w-7">
              <path d="M12 9v4m0 4h.01M10.3 3.9 2.6 17.5A1.5 1.5 0 0 0 4 19.8h16a1.5 1.5 0 0 0 1.4-2.3L13.7 3.9a1.5 1.5 0 0 0-2.6 0Z" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <h1 className="mt-4 font-display text-xl font-semibold text-turf-900">Etwas ist schiefgelaufen</h1>
          <p className="mt-2 text-sm text-ink-600">
            Ein unerwarteter Fehler hat die Seite zum Absturz gebracht. Das war wahrscheinlich ein einmaliger Aussetzer.
          </p>
          <p className="mt-2 max-w-full overflow-x-auto rounded-lg bg-chalk-100 px-3 py-2 font-mono text-xs text-ink-400">
            {this.state.error.message}
          </p>
          <button
            onClick={() => window.location.reload()}
            className="mt-6 h-11 w-full rounded-xl bg-turf-700 text-sm font-semibold text-chalk-50"
          >
            Seite neu laden
          </button>
        </main>
      );
    }
    return this.props.children;
  }
}
